import {postAuthorization} from '../api/postAuthorization';
import {setAuthorizeAction} from '../action';

export const setPostAuthorization = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await postAuthorization(params);

            if (data.status === 'success') {
                localStorage.setItem('token', data.token);
    
                dispatch(setAuthorizeAction(true))
                window.location.replace(window.location.origin);
            }
          
        } catch(error) {
            if (error?.response?.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}